import { render, staticRenderFns } from "./RelatorioPedidoListFiltro.vue?vue&type=template&id=6ddde5b3"
import script from "./RelatorioPedidoListFiltro.vue?vue&type=script&lang=js"
export * from "./RelatorioPedidoListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports